import React from "react";
import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { ThemeSettings } from "../../types/theme.js";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { useProfile } from "@ludens-reklame/rubics-v3-react/profile/hooks";
import { getLinkProps } from "../../client-utils/getLinkProps.js";
import { isAdminStorage } from "../../client-utils/constants.js";
import {
  hamburger,
  magnifyingGlass,

  userAvatar,
} from "../../client-utils/icons.js";

const Header: React.FC = () => {
  const store = useStore<ThemeSettings>();
  const site = store.site;
  const query = store.context.query;
  const themeSettings = store.themeSettings;
  const loggedIn = store.context.loggedIn;
  const menu = themeSettings.headerMenu || null;
  const user = useProfile();

  const isAdmin = isAdminStorage.get() || false;

  const [userMenuOpen, setUserMenuOpen] = React.useState<boolean>(false);
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState<boolean>(false);
  const [searchText, setSearchText] = React.useState<string>(
    (query.q as string) || "",
  );

  return (
    <header
      className={`header ${mobileMenuOpen || userMenuOpen ? "header-open" : ""}`}
    >
      <div className="container container-center hs flex">
        <div className="section">
          <div className="brand">
            {site.logo && (
              <a href="/" title="Gå til forsiden">
                <img
                  src={transformImageUrl(site.logo, { height: 80 })}
                  alt={site.name}
                />
              </a>
            )}
          </div>

          <div className="search">
            <SearchInput value={searchText} onChange={setSearchText} />
          </div>
          {menu && (
            <div className="menu">
              <ul>
                {(menu.items || []).map((item, index) => {
                  if (!item.link) return null;

                  return (
                    <li key={index}>
                      <a {...getLinkProps(item.link)} className="b2">
                        {item.link.title || item.link.text}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>

        <div className="section">
          {loggedIn && (
            <>
              {/* <div className="indicators">
                <ul>
                  <li>{notificationBell}</li>
                  <li>{star}</li>
                </ul>
              </div> */}
              {user.profile && (
                <div className="user">
                  <div
                    className="menu-trigger"
                    role="button"
                    onClick={() => {
                      setUserMenuOpen(!userMenuOpen);

                      if (mobileMenuOpen) {
                        setMobileMenuOpen(false);
                      }
                    }}
                  >
                    <div className="avatar">{userAvatar}</div>
                    <p className="b2">
                      {user.profile?.firstName} {user.profile?.lastName}
                    </p>
                  </div>
                  {userMenuOpen && (
                    <div className="user-menu b2">
                      <ul>
                        <li>
                          <a href="/min-side/#">Min profil</a>
                        </li>
                        {isAdmin && (
                          <li>
                            <a href="/min-side#mitt-team">Mitt team</a>
                          </li>
                        )}
                        <li>
                          <a href="/logg-ut">Logg ut</a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          <div className="mobile-menu-trigger">
            <button
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
                if (userMenuOpen) {
                  setUserMenuOpen(false);
                }
              }}
            >
              {hamburger}
            </button>
          </div>
        </div>
      </div>
      {mobileMenuOpen && (
        <div className="mobile-menu">
          <div className="search">
            <SearchInput value={searchText} onChange={setSearchText} />
          </div>
          {menu && (
            <ul>
              {(menu.items || []).map((item, index) => {
                if (!item.link) return null;

                return (
                  <li key={index}>
                    <a {...getLinkProps(item.link)} className="b2">
                      {item.link.title || item.link.text}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
          {loggedIn && user.profile && (
            <ul>
              <li>
                <a href="/min-side/#" className="b2">Min profil</a>
              </li>
              {isAdmin && (
                <li>
                  <a href="/min-side#mitt-team" className="b2">Mitt team</a>
                </li>
              )}
              <li>
                <a href="/logg-ut" className="b2">Logg ut</a>
              </li>
            </ul>
          )}
        </div>
      )}
    </header>
  );
};

interface SearchInputProps {
  value: string;
  onChange: (update: string | ((prevState: string) => string)) => void;
}

const SearchInput: React.FunctionComponent<SearchInputProps> = ({
  value,
  onChange,
}) => {
  return (
    <form action="/sokeresultater" method="GET">
      <input
        type="search"
        placeholder="Søk i hele nettsiden..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus
        name="q"
      />
      <button type="submit">{magnifyingGlass}</button>
    </form>
  );
};

export default Header;
